module.exports = __webpack_public_path__ + "static/media/long-logo-md.0e18c838.png";